import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CookieBanner from '../components/CookieBanner';

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header onSubscribeClick={() => {}} />
      
      <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <h1 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-4">
          Privacy Policy
        </h1>
        <p className="text-sm text-neutral-500 mb-12">
          Last updated: January 20, 2026
        </p>

        <div className="prose prose-lg max-w-none space-y-8 text-neutral-700">
          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">1. Introduction</h2>
            <p>
              Artinent.com ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">2. Information We Collect</h2>
            <p>We may collect information about you in a variety of ways:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Personal information such as name and email address when you subscribe to our newsletter</li>
              <li>Usage data including pages visited, time spent on pages, and referring websites</li>
              <li>Device information such as IP address, browser type, and operating system</li>
              <li>Cookies and tracking technologies</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">3. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Send you newsletters and updates</li>
              <li>Improve our website and user experience</li>
              <li>Analyze website usage and trends</li>
              <li>Respond to your inquiries and requests</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">4. GDPR Compliance</h2>
            <p>
              If you are located in the European Economic Area (EEA), you have certain data protection rights under the General Data Protection Regulation (GDPR):
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>The right to access your personal data</li>
              <li>The right to rectification of inaccurate data</li>
              <li>The right to erasure ("right to be forgotten")</li>
              <li>The right to restrict processing</li>
              <li>The right to data portability</li>
              <li>The right to object to processing</li>
            </ul>
            <p className="mt-4">
              To exercise these rights, please contact us at privacy@Artinent.com.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">5. Cookies</h2>
            <p>
              We use cookies to enhance your browsing experience. You can choose to accept or decline cookies through our cookie banner. Most web browsers automatically accept cookies, but you can modify your browser settings to decline cookies if you prefer.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">6. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">7. Third-Party Services</h2>
            <p>
              We may use third-party services that collect, monitor, and analyze information. These third parties have access to your information only to perform specific tasks on our behalf and are obligated not to disclose or use it for any other purpose.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">8. Children's Privacy</h2>
            <p>
              Our website is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">9. Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-900 mb-4">10. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us:
            </p>
            <p className="mt-4">
              News Pty Limited<br />
              ACN: 007 871 187 | ABN: 47 007 871 187<br />
              Email: privacy@Artinent.com<br />
              Address: 2 Holt Street, Surry Hills NSW 2010, Australia<br />
              Phone: +61 2 9288 3000
            </p>
          </section>
        </div>
      </main>

      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Privacy;
